export const CELL = 112;
export const BOARD = { x: 204, y: 380, size: CELL * 6 };
export type Piece = {
  id: string;
  col: number;
  row: number;
  w: number;
  h: number;
  tray?: [number, number];
  start?: number;
  land?: number;
};
export const pieces: Piece[] = [
  { id: "A", col: 0, row: 0, w: 3, h: 2 },
  { id: "B", col: 3, row: 0, w: 3, h: 1 },
  { id: "C", col: 3, row: 1, w: 3, h: 1 },
  { id: "D", col: 0, row: 2, w: 2, h: 2 },
  { id: "G", col: 0, row: 4, w: 2, h: 1 },
  {
    id: "F",
    col: 4,
    row: 2,
    w: 2,
    h: 2,
    tray: [80, 1180],
    start: 0.25,
    land: 1.4,
  },
  {
    id: "I",
    col: 4,
    row: 4,
    w: 2,
    h: 1,
    tray: [312, 1236],
    start: 1.45,
    land: 2.3,
  },
  {
    id: "H",
    col: 2,
    row: 4,
    w: 2,
    h: 1,
    tray: [544, 1236],
    start: 2.35,
    land: 3.1,
  },
  {
    id: "J",
    col: 0,
    row: 5,
    w: 2,
    h: 1,
    tray: [776, 1236],
    start: 3.15,
    land: 3.85,
  },
  {
    id: "K",
    col: 2,
    row: 5,
    w: 2,
    h: 1,
    tray: [192, 1496],
    start: 3.9,
    land: 4.55,
  },
  {
    id: "L",
    col: 4,
    row: 5,
    w: 2,
    h: 1,
    tray: [428, 1496],
    start: 4.6,
    land: 5.2,
  },
  {
    id: "E",
    col: 2,
    row: 2,
    w: 2,
    h: 2,
    tray: [664, 1440],
    start: 5.75,
    land: 8,
  },
];
const clamp = (v: number) => Math.max(0, Math.min(1, v));
const smooth = (v: number) => {
  const x = clamp(v);
  return x * x * x * (x * (x * 6 - 15) + 10);
};
export function position(piece: Piece, time: number) {
  const targetX = BOARD.x + piece.col * CELL;
  const targetY = BOARD.y + piece.row * CELL;
  if (
    !piece.tray ||
    piece.start === undefined ||
    piece.land === undefined ||
    time >= piece.land
  )
    return { x: targetX, y: targetY, height: 0, active: false };
  if (time <= piece.start)
    return { x: piece.tray[0], y: piece.tray[1], height: 0, active: false };
  const elapsed = time - piece.start;
  const duration = piece.land - piece.start;
  const lift = piece.id === "E" ? 0.2 : 0.12;
  const drop = piece.id === "E" ? 0.55 : 0.13;
  const hold = piece.id === "E" ? 0.35 : 0.08;
  const travel = duration - lift - hold - drop;
  const progress = smooth((elapsed - lift) / travel);
  const height =
    smooth(elapsed / lift) * (1 - smooth((elapsed - (duration - drop)) / drop));
  return {
    x: piece.tray[0] + (targetX - piece.tray[0]) * progress,
    y: piece.tray[1] + (targetY - piece.tray[1]) * progress,
    height,
    active: true,
  };
}
